module.exports = __webpack_public_path__ + "c602ced23e8412f9e0ed379bdecbd0f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fair/banner-mobile.jpg
// module id = ./assets/images/fair/banner-mobile.jpg
// module chunks = 0